<!-- 菜单栏 -->
<template>
    <div class="aside-waper">
        <el-menu
          :router="true"
          :default-active = "this.$route.path"
          class="el-menu-vertical-demo"
          background-color='#001529'
          text-color="#c4ccd6"
          active-text-color="#FFF"
        >
            <template v-for="(item,index) in menuItems">
                <template  v-if="item.submenu">
                    <el-submenu :key="index" :index="item.path">
                        <template slot="title">
                            <i class="el-icon-menu"></i>
                            <span>{{item.title}}</span>
                        </template>
                        <el-menu-item v-for="submenu in item.submenu" :key="submenu.id" :index="submenu.path">
                            <template>{{submenu.name}}</template>
                        </el-menu-item>
                    </el-submenu>
                </template>
                <template v-else>
                    <el-menu-item :key="index" :index="item.path">
                        <i :class="item.icon"></i>
                        <span slot="title">{{item.title}}</span>
                    </el-menu-item>
                </template>
            </template>
        </el-menu>
    </div>
</template>
<script>
import menu from "@/static/menu.js";
import axios from '@/utils/axios.js'
import { mapGetters, mapState } from 'vuex'
export default {
  name: "aside",
  data() {
    return {
        menuItems: menu
    };
  },
  computed:{
    ...mapGetters({
      user: 'getUser',
    })
  },
  mounted(){
    this.getMenu();
  },
  methods:{
    getMenu(){
      let _this = this;
      axios.post('/base/index/menus',{"username":_this.user.username}).then(function(res){
        let data = res.data.data;
        _this.menuItems = data;
      })



    }
  },
};
</script>
<style scoped>
.aside-waper {
    width: 100%;
    height: 100%;
    overflow:auto;
}

.el-menu-item.is-active{
    background: #2372EA !important;
}

.aside-waper>ul{
    margin-top:1.5rem
}
</style>




// WEBPACK FOOTER //
// src/views/common/aside.vue